import React from "react";

export default function ColorFrame39({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <circle
          cx="138"
          cy="156.264"
          r="106.696"
          fill="#fff"
          stroke="#5B9BFF"
          strokeWidth="24.609"
        ></circle>
        <rect
          width="71.27"
          height="74.487"
          x="98.897"
          y="19.302"
          fill="#5B9BFF"
          rx="8.661"
        ></rect>
        <rect
          width="48.008"
          height="23.014"
          x="110.528"
          y="11.879"
          fill="#5B9BFF"
          rx="3.217"
        ></rect>
        <rect
          width="54.938"
          height="14.848"
          x="106.815"
          fill="#D8E6FD"
          rx="3.217"
        ></rect>
        <rect
          width="2.092"
          height="6.187"
          x="111.27"
          y="4.207"
          fill="#D8E6FD"
          opacity="0.75"
          rx="1.046"
        ></rect>
        <rect
          width="2.092"
          height="6.187"
          x="140.561"
          y="4.207"
          fill="#D8E6FD"
          opacity="0.75"
          rx="1.046"
        ></rect>
        <rect
          width="2.092"
          height="6.187"
          x="125.916"
          y="4.207"
          fill="#D8E6FD"
          opacity="0.75"
          rx="1.046"
        ></rect>
        <rect
          width="2.092"
          height="6.187"
          x="155.207"
          y="4.207"
          fill="#D8E6FD"
          opacity="0.75"
          rx="1.046"
        ></rect>
        <rect
          width="2.092"
          height="6.187"
          x="118.592"
          y="4.207"
          fill="#D8E6FD"
          opacity="0.75"
          rx="1.046"
        ></rect>
        <rect
          width="2.092"
          height="6.187"
          x="147.884"
          y="4.207"
          fill="#D8E6FD"
          opacity="0.75"
          rx="1.046"
        ></rect>
        <rect
          width="2.092"
          height="6.187"
          x="133.238"
          y="4.207"
          fill="#D8E6FD"
          opacity="0.75"
          rx="1.046"
        ></rect>
        <path fill="#D8E6FD" d="M98.897 39.1H170.167V73.993H98.897z"></path>
        <path fill="#EA2F2F" d="M130.078 42.563H138.987V70.527H130.078z"></path>
        <path
          fill="#EA2F2F"
          d="M120.55 61H129.459V88.964H120.55z"
          transform="rotate(-90 120.55 61)"
        ></path>
        <rect
          width="34.15"
          height="17.323"
          fill="#D8E6FD"
          rx="8.661"
          transform="matrix(-1 0 0 1 122.406 79.189)"
        ></rect>
        <path
          fill="#EA2F2F"
          d="M122.406 87.85a8.661 8.661 0 00-8.661-8.661h-8.661v17.323h8.661a8.661 8.661 0 008.661-8.662z"
        ></path>
        {children}
      </g>
    </svg>
  );
}
